import { AppBar, Box, CssBaseline } from '@mui/material'
import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { OrganizationsProvider } from '../Organizations/Contexts/OrganizationsContext.jsx'
import LockedOrganizationDialog from '../Organizations/Dialogs/LockedOrganizationDialog.jsx'
import ErrorAlert from '../Shared/Alerts/ErrorAlert.jsx'
import SuccessAlert from '../Shared/Alerts/SuccessAlert.jsx'
import { useAuth } from '../Shared/Contexts/AuthContext.jsx'
import { UsersProvider } from '../Users/Contexts/UsersContext.jsx'
import Login from '../Users/Dialogs/Login.jsx'
import ResetPassword from '../Users/Dialogs/ResetPassword.jsx'
import ResetPasswordSuccess from '../Users/Dialogs/ResetPasswordSuccess.jsx'
import Footer from './Footer/Footer.jsx'
import NavBar from './Navbar/NavBar.jsx'

const MainLayout = () => {
  const { pathname } = useLocation()
  const { authState: { isAuthenticated }, refreshSelfOrganizations } = useAuth()
  const wasInManagement = useRef(false)
  const isInManagement = isAuthenticated && (pathname === '/management' || pathname.startsWith('/management/'))

  useEffect(() => {
    if (isInManagement && !wasInManagement.current) {
      refreshSelfOrganizations()
    }
    wasInManagement.current = isInManagement
  }, [isInManagement, refreshSelfOrganizations])

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          enableColorOnDark
        >
          <UsersProvider>
            <OrganizationsProvider>
              <NavBar />
            </OrganizationsProvider>
          </UsersProvider>
        </AppBar>
        <Outlet />
      </Box>
      <Footer />
      <SuccessAlert></SuccessAlert>
      <ErrorAlert></ErrorAlert>
      <Login />
      <ResetPassword />
      <ResetPasswordSuccess />
      <LockedOrganizationDialog />
    </>
  )
}

export default MainLayout
